export const API_HOST = process.env.API_HOST || "localhost:8080";
export const API_PROTOCOL = process.env.API_PROTOCOL || "http";
export const API_URL_PREFIX = `${API_PROTOCOL}://${API_HOST}/internal_api`;
export const GLOBAL = {
  apiUrl: {
    landings: `${API_URL_PREFIX}/landings/`,
    blocks: `${API_URL_PREFIX}/blocks/`,
    login: `${API_PROTOCOL}://${API_HOST}/authentication`,
    refresh_token: `${API_PROTOCOL}://${API_HOST}/token/refresh`,
    user: `${API_URL_PREFIX}/user/`,
    users: `${API_URL_PREFIX}/user/list`
  },
  baseLandingId: "60363685910ae148a3613182",
  baseColor: "#00838F",
  s3Url: `${API_PROTOCOL}://${API_HOST}/sfiles/`,
  inputType: "input",
  textareaType: "textarea",
  htmlType: "html",
  imageType: "image",
  checkboxType: "checkbox",
  selectType: "select",
  metaType: "meta",
  formType: "form",
  numberType: "number",
  hiddenType: "hidden",
  rules: {
    required: v => !!v || "Поле обязательно для заполнения",
    email: [
      v => !!v || "E-mail is required",
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail must be valid"
    ]
  },
  defaultErrorText: "Ошибка подгрузки данных",
  schemaHelpUrl: "https://doc.office.lan/pages/viewpage.action?pageId=13799175"
};
